import { createFileRoute } from '@tanstack/react-router'
import { WebhooksSettingsPage } from '../../../../components/webhooks/WebhooksSettingsPage'

export const Route = createFileRoute('/$org/settings/webhooks/')({
    component: WebhooksSettingsPage,
})
